import { useScrollableSource } from '@eas/common-web';
import { User, RoleInstance } from '../../../../models';
import { EvidenceAPI } from '../../../../enums';
import { useColumns } from './role-empowered-columns';

export function useEmpoweredRoles(profile: User) {
  const source = useScrollableSource<RoleInstance>({
    url: `${EvidenceAPI.USERS}/${profile.id}/role/empowered/instance/list`,
  });

  const columns = useColumns();

  return {
    source,
    columns,
  };
}
